export const NOTICE_TYPE_WITH_OUT_AUTH_REQUEST = 'NOTICE_TYPE_WITH_OUT_AUTH_REQUEST';
export const NOTICE_TYPE_WITH_OUT_AUTH_SUCCESS = 'NOTICE_TYPE_WITH_OUT_AUTH_SUCCESS';
export const NOTICE_TYPE_WITH_OUT_AUTH_FAIL    = 'NOTICE_TYPE_WITH_OUT_AUTH_FAIL';

